.ds{aspect-ratio:1/1;}